import { useEffect } from "react";

/**
 * Hook que habilita y deshabilita automáticamente el modo de pantalla completa (`fullscreen`)
 * en la aplicación durante el montaje y desmontaje del componente.
 *
 * - Al montar, establece `isFullscreen` en `true` si no lo está.
 * - Al desmontar, restablece `isFullscreen` a `false` si no lo está ya.
 *
 * Este hook es útil para garantizar que ciertas vistas como exámenes se muestren en pantalla completa.
 *
 * @param {Object} params - Parámetros necesarios para controlar el modo fullscreen.
 * @param {Object} params.config - Objeto de configuración de la aplicación (por ejemplo, desde context).
 * @param {Function} params.setConfig - Función para actualizar el valor de configuración global.
 */
const useFullscreenMode = ({ config, setConfig }) => {
	useEffect(() => {
		if (config.isFullscreen !== true) setConfig('isFullscreen', true);
		return () => {
			if (config.isFullscreen !== false) setConfig('isFullscreen', false);
		};
	}, [setConfig, config.isFullscreen]);
};

export default useFullscreenMode;